import { useEffect } from "react";
import { UploadImage, Flex, SubText } from "@base-ui";
import Image from "@cms/components/ui/Image";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function ImageUploader(props) {
  var activeImage = props.activeImage,
    setActiveImage = props.setActiveImage;
  useEffect(function () {
    if (!activeImage) return;
    var reader = new FileReader();
    var imgTag = document.getElementById("active-image-for-imageselect");
    imgTag.title = activeImage.name;
    reader.onload = function (e) {
      imgTag.src = e.target.result;
    };
    reader.readAsDataURL(activeImage);
  }, [activeImage]);
  var uploadedImage = (activeImage === null || activeImage === void 0 ? void 0 : activeImage.name) && /*#__PURE__*/_jsx(Flex.Column, {
    flex: "1",
    children: /*#__PURE__*/_jsx(Image, {
      id: "active-image-for-imageselect",
      src: activeImage.name,
      alt: activeImage.name,
      height: "157px"
    })
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SubText, {
      as: "label",
      htmlFor: "active-image-for-imageselect",
      children: "Vald poster bild:"
    }), /*#__PURE__*/_jsxs(Flex.Row, {
      flex: "1",
      height: "150px",
      children: [uploadedImage, /*#__PURE__*/_jsx(UploadImage, {
        id: "upload-image-button",
        callback: function callback(files) {
          return files[0] && setActiveImage(files[0]);
        },
        flex: "1"
      })]
    })]
  });
}